import {Helper} from "../../core/util/helper";
import {HTTPService, JsonResultClass} from "../../core/util/httpManager";
import {AppHelper} from "../../appHelper";
import {AppBaseProps, CommonApp, Entity} from "../../core/components/commonApp";
import {General} from "../../../siteManagement/general";
import {Sheet, SheetEventType} from "../../../siteManagement/sheet";
import {NotificationHelper} from "../../core/util/notificationHelper";
import {DialogHelper} from "../../core/util/dialogHelper";
import React from "react";

export class KendoTemplateHelper {
    public static editTemplate = (id) => {
        const url = `KendoTemplate/Edit?id=${id}`;
        return KendoTemplateHelper.openSheet(url);
    }

    public static newTemplate = () => {
        const url = "KendoTemplate/CreateNew";
        return KendoTemplateHelper.openSheet(url);
    }

    private static openSheet = (entityUrl: string) => {
        return new Promise<KendoTemplateSheetResult>(async (resolve, reject) => {
            const [entityResult, metaData] = await Promise.all([
                HTTPService.get<JsonResultClass<KendoTemplateEntity>>(entityUrl),
                Helper.getMetaData("kendoTemplate"),
            ]);
            if (entityResult.Code != 0) {
                reject(entityResult.Message);
            }

            const sheet = General.Sheet.Manager.createSheet();
            const props: EditKendoTemplateProps = {
                context: {
                    contextType: "kendoTemplate",
                },
                dataSources: { },
                entity: entityResult.Data,
                isWindow: false,
                metadata: metaData,
                onClose: (resultType: KendoTemplateSheetResult) => {
                    resolve(resultType);
                }
            };
            sheet.show(() => {
                sheet.mountContent(EditKendoTemplate, props);
            })
        });
    }


    public static delete = (id: string) => {
        return new Promise<boolean>(async (resolve) => {
            const result = await HTTPService.post<JsonResultClass>(`KendoTemplate/Delete?id=${id}`);
            if (result.Code == 0)
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Ressource.LöschenErfolgreich"));
            else
                NotificationHelper.showErrorMessage(result.Message);
            resolve(result.Code === 0);
        })
    }
}

export enum KendoTemplateSheetResult {
    JustClosed = 0,
    SavedSuccessfully = 1,
    DeletedSuccessfully = 2
}

class EditKendoTemplate extends React.Component<EditKendoTemplateProps, { resultType: KendoTemplateSheetResult }> {
    common = new AppHelper();
    showClearButton = false;
    private sheet: Sheet;

    constructor(props) {
        super(props)
        this.common.enableHooks = false;
        this.common.init(this);
        this.state = {
            resultType: KendoTemplateSheetResult.JustClosed
        }
        this.initApp();
    }

    private initApp = () => {
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.sheet.bind(SheetEventType.Close, () => {
            this.props.onClose(this.state.resultType);
        });
        $(window).on("tabStripTabSelected", (_, data: { index: number }) => {
            this.showClearButton = data.index === 1;
            this.setState({});
        });
        this.setTitle();
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    save = async () => {
        if (!this.common.validate()) {
            return;
        }
        const result = await HTTPService.post<JsonResultClass<string>>("KendoTemplate/Save", { entity: this.props.entity });
        if (result.Code == 0) {
            NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.Msg.SpeichernErfolgreich"));
            if (this.props.entity.IsNew) {
                this.props.entity.IsNew = false;
                this.props.entity.Id = result.Data;
            }
        } else {
            NotificationHelper.showErrorMessage(result.Message);
        }

        this.common.handlePostSave(result.Code === 0, false);
        this.setState({
            resultType: KendoTemplateSheetResult.SavedSuccessfully
        });
    }

    remove = async () => {
        const ok = await DialogHelper.confirm(__internal_translations["Standard.Msg.Loeschen"]);
        if (ok) {
            const result = await HTTPService.post<JsonResultClass>(`KendoTemplate/Delete?id=${this.props.entity.Id}`);
            if (result.Code == 0) {
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Ressource.LöschenErfolgreich"));
                this.setState({
                    resultType: KendoTemplateSheetResult.DeletedSuccessfully
                }, () => {
                    this.sheet.hide();
                })
            }
            else
                NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private setTitle = () => {
        // let title = this.props.metadata.pageTitle + " " + this.props.entity.Title;
        //
        // this.sheet.setTitle(title);
    }


    componentDidUpdate() {
        this.setTitle();
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}

interface EditKendoTemplateProps extends AppBaseProps {
    entity: KendoTemplateEntity;
    onClose: (resultType: KendoTemplateSheetResult) => void;
}

interface KendoTemplateEntity extends Entity{
    Id: string;
    Title: string;
    Template: string;
}

